import {defineStore} from 'pinia'
import {isEmpty} from "lodash";

/**
 * Features using this store:
 * When adding domain name to a group from the information tab -> internet filter log
 * Groups tab
 *
 */
export const useGroupsStore = defineStore('groups', {
    state: () => {
        return {
            groups: [],
            groupsInitialState: [],
            currentSelectedGroup: '',
            currentSelectedGroupName: '',
            currentSelectedGroupDestDomainsString: '',
        }
    },
    actions: {

        setGroups(groups) {
            this.groups = groups
        },
        getGroups() {
            return this.groups;
        },
        getGroupsInitialState() {
            if (typeof this.groupsInitialState !== 'undefined' && ! isEmpty(this.groupsInitialState)) {
                return JSON.parse(this.groupsInitialState);
            }
        },
        setGroupsInitialState(groups) {

            if (typeof groups === 'object') {
                this.groupsInitialState = JSON.stringify(groups);
            }

        },

        sortGroups() {

            // Sort groupsKeyValue by key where child is present, and then sort alphabetically, further for the els that do not have child, sort alphabetically.
            this.groups.sort((a, b) => {

                if (a.child && !b.child) {
                    return -1
                } else if (!a.child && b.child) {
                    return 1
                } else if (a.child && b.child) {
                    return a.key.localeCompare(b.key)
                } else {
                    return a.key.localeCompare(b.key)
                }

            });

            // Further the groupsKeyValue would either have a child or not, if the child is present, then we go to child.value.dest_domains and sort that
            // alphabetically. If the child is not present, then we go to value.dest_domains and sort that alphabetically.
            this.groups.map((group) => {

                if (group.child) {

                    group.child.map((child) => {

                        if (child.value.dest_domains) {
                            child.value.dest_domains.sort()
                        }

                    });

                } else {

                    if (group.value.dest_domains) {
                        group.value.dest_domains.sort()
                    }

                }

            });

        }

    }

})
